import React from 'react'
import ErrorsContext from '../contexts/ErrorsContext'
import { isObservable, toJS } from 'mobx'
import { getMapValue } from '@morningtrain/react-helpers'

export default function useErrors (name = null) {
  const errors = React.useContext(ErrorsContext)

  if (name === null) {
    return errors
  }

  if (!errors) {
    throw new Error('In useError for ' + name + ' - Errors are falsy, are they provided?')
  }

  let error = null

  if (typeof errors.get === 'function') {
    const nameFragments = name.split(/[\[\]\.]/).filter(function (part) {
      return part !== ''
    })

    const dottedName = nameFragments.join('.')

    if (errors.has(dottedName)) {
      error = errors.get(dottedName)
    } else {
      error = getMapValue(errors, name, null)
    }
  }

  if (isObservable(error)) {
    error = toJS(error)
  }

  return error
}
